<template>
    <div class="footer-wrap">
        <div id="tsa-pc-footer"></div>
    </div>
</template>

<script>
import 'tsa-components-umd/dist/tsa-components-umd.min.css'
const TsaComponentsUmd = require('tsa-components-umd')
export default {
    props: {
        currentTime:{
            type: Number,
            default:new Date().getTime(),
        },
        footerContent: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        return {
            
        }
    },
    components: {},
    computed: {
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            TsaComponentsUmd.pcFooter({
                type: 'ipr',
                el: '#tsa-pc-footer',
                env: process.env.VUE_APP_ENV,
                clientId: "952310",
                hasFriendsLink:true,
                currentLink:process.env.VUE_APP_COPYRIGHT,
                currentTimeApi:'/content-plus/api/time/currentTime'
            })
            TsaComponentsUmd.toggleLang(this.$i18n.locale);
        })
    },
    methods: {
        
    },
}

</script>
<style src="./css/footer.less" lang="less" scoped></style>